import React, { useState } from 'react';
import { createTodos, uploadUkeplan } from '../../../utils/FamilyApiService';
import styled from 'styled-components'
import './Admin.css';

const UkeplanInputStyled = styled.input`
    width: 300px;
`;

const Admin = ({
    familyMemberName
}) => {

    const [sivertUrlUkeplan, setSivertUrlUkeplan] = useState('');
    const [jennyUrlUkeplan, setJennyUrlUkeplan] = useState('');
    const [sivertUkeplanIsLoading, setSivertUkeplanIsLoading] = useState(false);
    const [jennyUkeplanIsLoading, setJennyUkeplanIsLoading] = useState(false);

    const handleSivertUploadUkeplan = async () => {
      setSivertUkeplanIsLoading(true);
      await uploadUkeplanInternal('sivert', sivertUrlUkeplan);
      setSivertUkeplanIsLoading(false);
  }

    
    const handleJennyUploadUkeplan = async () => {
      setJennyUkeplanIsLoading(true);
      await uploadUkeplanInternal('jenny', jennyUrlUkeplan);
      setJennyUkeplanIsLoading(false);
  }

  async function uploadUkeplanInternal(kidName, ukeplanUrl) {
    try {
      await uploadUkeplan(kidName, ukeplanUrl);
    } catch (error) {
      console.error(error);
    } 
  };

    async function createWeeklyTasks()
    {
        await createTodos();
    }
    

  return (
    <div>
      <div>
        <button onClick={async () => await createWeeklyTasks() }>Opprett ukesoppgaver</button>
      </div>
      <div>
          <UkeplanInputStyled 
              type="text" 
              value={sivertUrlUkeplan} 
              onChange={(e) => setSivertUrlUkeplan(e.target.value)} 
              placeholder="Ukeplan Sivert" 
          />
          {sivertUkeplanIsLoading && <div className="buttonSpinner" style={{ display: sivertUkeplanIsLoading ? 'block' : 'none' }}></div>}
          <button disabled={sivertUkeplanIsLoading} onClick={handleSivertUploadUkeplan}>Last opp Sivert sin ukeplan</button>
      </div>
      <div>
          <UkeplanInputStyled
              type="text" 
              value={jennyUrlUkeplan} 
              onChange={(e) => setJennyUrlUkeplan(e.target.value)} 
              placeholder="Ukeplan Jenny" 
          />
          {jennyUkeplanIsLoading && <div className="buttonSpinner" style={{ display: jennyUkeplanIsLoading ? 'block' : 'none' }}></div>}
          <button disabled={jennyUkeplanIsLoading} onClick={handleJennyUploadUkeplan}>Last opp Jenny sin ukeplan</button>
      </div>
    </div>


  );
};

export default Admin;
